import { Pipe, PipeTransform } from '@angular/core';
import { rutFormat } from 'rut-helpers';

@Pipe({ name: 'rutPipe' })
export class RutPipe implements PipeTransform {
  transform(value: any): string {
    return rutFormat(value);
  }
}
